import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { toast } from 'react-toastify';
import { put } from '../../controllers/apiController';
import { useAuth } from '../../context/AuthContext';

const Profil = () => {
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [profileImage, setProfileImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    const { user } = useAuth();

    useEffect(() => {
        document.title = "Profil | LEVELUP CRM";

        setName(user.Kullanici_Adi);
        setSurname(user.Kullanici_Soyadi);
    }, [user]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 1 * 1024 * 1024) { // 5MB kontrol
                toast.error("Dosya boyutu 1MB'dan küçük olmalıdır!");
                return;
            }

            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
            if (!validTypes.includes(file.type)) {
                toast.error("Sadece JPG, JPEG, PNG ve WEBP formatları desteklenmektedir!");
                return;
            }

            setProfileImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const saveProfile = async () => {
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('surname', surname);
            if (profileImage) {
                formData.append('profileImage', profileImage);
            }

            await put("users/me/update", formData);
            toast.success("Profil bilgileri başarıyla güncellendi");
        } catch (error) {
            toast.error("Profil güncellenirken bir hata oluştu");
        }
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content without-header nxl-full-content">
                    <div className="main-content d-flex">
                        <div className="content-sidebar content-sidebar-md" data-scrollbar-target="#psScrollbarInit">
                            <div className="content-sidebar-header bg-white sticky-top hstack justify-content-between">
                                <h4 className="fw-bolder mb-0">Profil Ayarları</h4>
                                <a href="javascript:void(0);" className="app-sidebar-close-trigger d-flex">
                                    <i className="feather-x"></i>
                                </a>
                            </div>
                            <div className="content-sidebar-body">
                                <ul className="nav flex-column nxl-content-sidebar-item">
                                    <li className="nav-item">
                                        <a className="nav-link active" href="./my-account">
                                            <i className="feather-user"></i>
                                            <span>Profil Bilgileri</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="./change-password">
                                            <i className="feather-lock"></i>
                                            <span>Şifre Değiştir</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="content-area ps ps--active-y" data-scrollbar-target="#psScrollbarInit">
                            <div className="content-area-header bg-white sticky-top">
                                <div className="page-header-left">
                                    <a href="javascript:void(0);" className="app-sidebar-open-trigger me-2">
                                        <i className="feather-align-left fs-24"></i>
                                    </a>
                                </div>
                                <div className="page-header-right ms-auto">
                                    <div className="d-flex align-items-center gap-3 page-header-right-items-wrapper">
                                        <button href="javascript:void(0);" onClick={saveProfile} className="btn btn-primary">
                                            <i className="feather-save me-2"></i>
                                            <span>Kaydet</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="content-area-body">
                                <div className="card mb-0">
                                    <div className="card-body">
                                        <div className="mb-5">
                                            <div className="mb-3 d-flex justify-content-center">
                                                <img 
                                                    src={previewImage || user.Profil_Gorseli} 
                                                    className="img-fluid rounded wd-100 hd-100" 
                                                    alt="Profil Resmi" 
                                                    style={{objectFit: 'cover'}}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Profil Fotoğrafı</label>
                                                <input 
                                                    className="form-control" 
                                                    type="file" 
                                                    accept=".jpg, .jpeg, .png, .webp" 
                                                    onChange={handleImageChange}
                                                />
                                                <small className="text-muted">Maksimum dosya boyutu: 5MB. İzin verilen formatlar: JPG, JPEG, PNG, WEBP</small>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">İsim</label>
                                                <input type="text" className="form-control" placeholder="İsim" value={name} onChange={(e) => setName(e.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Soyisim</label>
                                                <input type="text" className="form-control" placeholder="Soyisim" value={surname} onChange={(e) => setSurname(e.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">E-Posta Adresi</label>
                                                <input type="email" className="form-control" placeholder="E-Posta Adresi" disabled readOnly value={user.Kullanici_Email} />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Kayıtlı Firma</label>
                                                <input type="text" className="form-control" placeholder="Kayıtlı Firma" value={user.Firma.Firma_Adi} disabled readOnly />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Yetki</label>
                                                <input type="text" className="form-control" placeholder="Yetki" value={(user.Kullanici_Yetki == 0 ? "Admin" : "Temsilci")} disabled readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default Profil;
